<template>
  <div class="comment-section">
    <slot />
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.comment-section {
  background-color: $grey15;
  padding: 8px;
}
</style>